export const mutations = {
  'SET_CATEGORY_LIST'(state, data) {
    state.category_list = data
  }
};